import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    top: {
        flexShrink: 0,
        display: 'flex',
        marginBottom: 4,
        height: 32,
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
        overflow: 'hidden',
    },
    avaLink: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 6,
        paddingRight: 6,
        paddingBottom: 6,
        paddingLeft: 12,
        width: 110,
        backgroundColor: theme.palette.ava.blue5,
        color: theme.palette.ava.dark1,
        fontSize: 16,
        lineHeight: '20px',
    },
    inputContainer: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: 6,
        paddingBottom: 6,
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
        border: `1px solid ${theme.palette.ava.grey6}`,
        overflow: 'hidden',
    },
    inputContainerFocused: {
        border: `1px solid ${theme.palette.ava.blue2}`,
    },
    iconContainer: {
        height: 20,
        width: 40,
    },
    icon: {
        height: '100%',
        width: '100%',
    },
    input: {
        paddingRight: 12,
        height: '100%',
        width: '100%',
        background: 'transparent',
        border: 'none',
        outline: 'none',
        fontSize: 16,
        color: theme.palette.ava.blue2,
        caretColor: theme.palette.ava.blue2,
        '&::placeholder': {
            color: theme.palette.ava.grey6,
        },
        '&:focus::placeholder': {
            color: theme.palette.ava.grey5,
        },
    },
    bottom: {
        marginBottom: 20,
        width: '100%',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    card: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: 4,
        paddingRight: 8,
        paddingBottom: 4,
        paddingLeft: 8,
        height: 32,
        width: '100%',
        background: 'rgba(0, 0, 0, 0.5)',
        backgroundBlendMode: 'overlay',
        border: `1px solid ${theme.palette.ava.blue2}`,
        overflow: 'hidden',
        cursor: 'pointer',
        '&:hover': {
            background: theme.palette.ava.navy2,
        },
        '&:first-child': {
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
        },
        '&:last-child': {
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
        },
    },
    avatar: {
        marginRight: 8,
    },
    avaName: {
        fontSize: 14,
        lineHeight: '18px',
    },
}));
export default useStyles;
